// frontend/src/components/common/ErrorState.tsx
// Red banner with "Could not load:" prefix and optional retry button.
// Shared across pages so every data-load failure looks the same.

import React from "react";

interface ErrorStateProps {
  /** The error message to display (prefixed with "Could not load:"). */
  message: string;
  /** When provided, renders a "Try again" button on the right. */
  onRetry?: () => void;
  /** Label for the retry button. Defaults to "Try again". */
  retryLabel?: string;
  /** Text before the message. Defaults to "Could not load:". */
  prefix?: string;
}

export default function ErrorState({
  message,
  onRetry,
  retryLabel = "Try again",
  prefix = "Could not load:",
}: ErrorStateProps): React.ReactElement {
  return (
    <div
      role="alert"
      style={{
        padding: 16,
        background: "#FEE2E2",
        border: "1px solid #F87171",
        borderRadius: 10,
        color: "#991B1B",
        fontSize: 13,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 12,
      }}
    >
      <div>
        <strong>{prefix}</strong> {message}
      </div>
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            padding: "6px 12px",
            background: "transparent",
            border: "1.5px solid #991B1B",
            borderRadius: 8,
            color: "#991B1B",
            fontSize: 12,
            fontWeight: 700,
            cursor: "pointer",
            whiteSpace: "nowrap",
          }}
        >
          {retryLabel}
        </button>
      )}
    </div>
  );
}